const anonymousSvg = encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
    <defs>
      <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#cbd5e1"/>
        <stop offset="100%" stop-color="#94a3b8"/>
      </linearGradient>
    </defs>
    <rect width="200" height="200" rx="40" fill="url(#g)"/>
    <circle cx="100" cy="76" r="34" fill="#e2e8f0"/>
    <path d="M48 166c7-28 29-44 52-44s45 16 52 44" fill="#e2e8f0"/>
  </svg>
`);

export const ANONYMOUS_NAME = 'Anonymous';
export const ANONYMOUS_PHOTO_URL = `data:image/svg+xml;charset=utf-8,${anonymousSvg}`;

export function getUserDisplayName(user = {}) {
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
  return fullName || user?.email || 'Unknown User';
}

export function resolvePublicProfile(user = {}, viewerUid = '') {
  const ownerUid = String(user?.uid || user?.id || '').trim();
  const isSelf = Boolean(ownerUid) && ownerUid === String(viewerUid || '').trim();
  const visibility = user?.profileVisibility === 'private' ? 'private' : 'public';
  if (!isSelf && visibility === 'private') {
    return {
      name: ANONYMOUS_NAME,
      photoUrl: ANONYMOUS_PHOTO_URL,
      isAnonymous: true,
      visibility,
    };
  }

  return {
    name: getUserDisplayName(user),
    photoThumbPath: user?.photoThumbPath || '',
    photoPath: user?.photoPath || '',
    photoUrl: ANONYMOUS_PHOTO_URL,
    isAnonymous: false,
    visibility,
  };
}
